import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Foto_3 from "../../Media/nivel1.png";
import Foto_6 from "../../Media/tickets.png";
import Foto_7 from "../../Media/moduleTickets.png";
import RadioWaveRings from "../Elements/RadioWaveRings";

export default function LevelsPage() {
  const { t } = useTranslation("levels");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {/* Hero section */}
      <div className="isolate relative overflow-hidden bg-gradient-to-br from-navy-950 via-navy-900 to-electric-700 pt-14">
        <div
          className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[50rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-electric-400 to-neon-300 opacity-20 sm:left-[calc(50%-30rem)] sm:w-[100rem]"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          />
        </div>
        <div className="py-24 sm:py-32">
          <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-6 lg:grid-cols-2 lg:px-8">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-1.5 text-sm font-medium text-neon-300">
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-neon-300 opacity-75"></span>
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-neon-300"></span>
                </span>
                {t("hero.badge")}
              </span>
              <h1 className="mt-6 text-4xl font-bold tracking-tight text-white sm:text-5xl">
                {t("hero.headingPrefix")} <span className="text-neon-300">{t("hero.headingHighlight")}</span>
              </h1>
              <p className="mt-6 text-lg leading-8 text-white/70">
                {t("hero.description")}
              </p>
              <div className="mt-10 flex flex-row flex-wrap items-start gap-3 sm:gap-4">
                <Link
                  to="/contact"
                  state="demo-rfid"
                  className="rounded-md bg-neon-300 px-4 py-2.5 text-sm font-semibold text-navy-900 shadow-sm transition hover:bg-neon-400 sm:px-5 sm:py-3 sm:text-base"
                >
                  {t("hero.ctaPrimary")}
                </Link>
                <Link
                  to={{ pathname: "/", hash: "#casos-de-exito" }}
                  className="rounded-md border border-white/30 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-white/10 sm:px-5 sm:py-3 sm:text-base"
                >
                  {t("hero.ctaSecondary")}
                </Link>
              </div>
            </div>
            <div className="relative hidden lg:block">
              <div
                className="pointer-events-none absolute -bottom-20 -right-10 h-64 w-64 blur-sm sm:-bottom-28 sm:-right-20 sm:h-80 sm:w-80"
                aria-hidden="true"
              >
                <RadioWaveRings className="absolute inset-0" />
              </div>
              <div className="relative z-10 overflow-hidden rounded-2xl border border-white/10">
                <img src={Foto_7} className="h-72 w-full object-cover" alt={t("hero.imageAlt")} />
              </div>
            </div>
          </div>
        </div>

        <div
          className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-50rem)]"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-navy-400 to-electric-300 opacity-25 sm:left-[calc(50%+36rem)] sm:w-[100rem]"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          />
        </div>
      </div>

      {/* ¿QUÉ INCLUYE? */}
      <div className="mx-auto max-w-7xl px-6 pt-24 sm:pt-32 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-base font-semibold leading-7 text-electric-600">{t("intro.eyebrow")}</h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{t("intro.heading")}</p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            {t("intro.description")}
          </p>
        </div>
      </div>

      {/* NIVEL 1: SELF SERVICE */}
      <div className="mx-auto max-w-7xl px-6 py-12 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
          <div className="overflow-hidden rounded-2xl border border-gray-200">
            <img src={Foto_3} className="h-72 w-full object-cover" alt={t("level1.imageAlt")} />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-navy-900">{t("level1.title")}</h2>
            <p className="mt-3 text-base leading-7 text-gray-600">
              {t("level1.description")}
            </p>
            <ul className="mt-4 space-y-2">
              {t("level1.items", { returnObjects: true }).map((item) => (
                <li key={item} className="flex gap-2 text-sm text-gray-600">
                  <span className="text-electric-500">&bull;</span>{item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* NIVEL 2: ASISTENCIA TÉCNICA */}
      <div className="mx-auto max-w-7xl px-6 py-12 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
          <div className="lg:order-2 overflow-hidden rounded-2xl border border-gray-200">
            <img src={Foto_6} className="h-72 w-full object-cover" alt={t("level2.imageAlt")} />
          </div>
          <div className="lg:order-1">
            <h2 className="text-2xl font-bold text-navy-900">{t("level2.title")}</h2>
            <p className="mt-3 text-base leading-7 text-gray-600">
              {t("level2.description")}
            </p>
            <ul className="mt-4 space-y-2">
              {t("level2.items", { returnObjects: true }).map((item) => (
                <li key={item} className="flex gap-2 text-sm text-gray-600">
                  <span className="text-electric-500">&bull;</span>{item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* NIVEL 3: SOPORTE UNO A UNO */}
      <div className="mx-auto max-w-7xl px-6 py-12 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
          <div className="overflow-hidden rounded-2xl border border-gray-200">
            <img
              src="https://images.unsplash.com/photo-1515879218367-8466d910aaa4?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              className="h-72 w-full object-cover"
              alt={t("level3.imageAlt")}
            />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-navy-900">{t("level3.title")}</h2>
            <p className="mt-3 text-base leading-7 text-gray-600">
              {t("level3.description")}
            </p>
            <ul className="mt-4 space-y-2">
              {t("level3.items", { returnObjects: true }).map((item) => (
                <li key={item} className="flex gap-2 text-sm text-gray-600">
                  <span className="text-electric-500">&bull;</span>{item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* CIERRE */}
      <div className="mt-24 mb-24 bg-neon-300 rounded-lg sm:mt-32 sm:mb-32 max-w-7xl mx-auto px-6 py-16 lg:px-8">
        <div className="mx-auto max-w-xl text-center">
          <p className="text-3xl font-bold tracking-tight text-navy-900 sm:text-4xl">
            {t("closing.heading")}
          </p>
          <Link
            to="/contact"
            state="demo-rfid"
            className="mt-8 inline-flex items-center rounded-md bg-navy-900 px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-navy-800"
          >
            {t("closing.cta")}
          </Link>
        </div>
      </div>
    </div>
  );
}
